import Pressure from "./Pressure";
import Camera from "./Camera";
import { PeripheralResponse, PeripheralType } from "./type";
import { logDev } from "utils/logs";

interface Listener {
  type: PeripheralType;
  identify_info: string;
  callback: (data: any) => void;
}

class Peripheral {
  public readonly extensions = {
    [PeripheralType.CAMERA]: new Camera(),
    [PeripheralType.PRESSURE]: new Pressure(),
  };

  protected messages = new Map<PeripheralType, PeripheralResponse>();

  protected listeners: Listener[] = [];

  public anyMessage?: (data: PeripheralResponse) => void;

  constructor() {
    Object.keys(this.extensions).map((type) => {
      const extension = this.extensions[type as PeripheralType];
      extension.onResponse((response) => {
        this.anyMessage?.(response);
        this.messages.set(type as PeripheralType, response);
        this.listeners.forEach((listener) => {
          if (
            listener.type === type &&
            listener.identify_info === response.identify_info
          ) {
            listener.callback(response.data);
            this.messages.delete(type as PeripheralType);
          }
        });
      });
    });
  }

  public request(type: PeripheralType, identify_info: string) {
    logDev("new request UVC Device", type, identify_info);
    this.extensions[type].request(identify_info);
  }

  public onMessage<T = any>(
    type: PeripheralType,
    identify_info: string,
    callback: (data: T) => void
  ) {
    this.checkQueueMessage(type, identify_info, callback);

    this.listeners.push({ type, callback, identify_info });

    const index = this.listeners.length;

    return () => {
      this.listeners.splice(index, 1);
    };
  }

  protected checkQueueMessage<T = any>(
    type: PeripheralType,
    identify_info: string,
    callback: (data: T) => void
  ) {
    if (this.messages.has(type)) {
      const message = this.messages.get(type);
      if (message?.identify_info === identify_info) {
        callback(message?.data);
        this.messages.delete(type);
      }
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Peripheral();
